import { Capacitor } from '@capacitor/core';

const GOOGLE_PLAY_MONTHLY_PRODUCT_ID = process.env.REACT_APP_GOOGLE_PLAY_MONTHLY_PRODUCT_ID || 'premium_monthly';

const toPurchase = (raw) => ({
  purchaseToken: raw?.purchaseToken || raw?.purchase_token || '',
  productId: raw?.productId || raw?.product_id || GOOGLE_PLAY_MONTHLY_PRODUCT_ID,
  orderId: raw?.orderId || raw?.order_id || '',
  status: raw?.isAcknowledged === false ? 'PENDING' : 'ACTIVE',
});

export class GooglePlayBillingProvider {
  get plugin() {
    return Capacitor?.Plugins?.GooglePlayBilling || Capacitor?.Plugins?.PlayBilling || null;
  }

  async startSubscription(productId = GOOGLE_PLAY_MONTHLY_PRODUCT_ID) {
    if (Capacitor.getPlatform() !== 'android') {
      return { success: false, message: 'Google Play Billing disponible uniquement sur Android.' };
    }

    const billing = this.plugin;
    if (!billing) {
      return { success: false, message: 'Plugin Google Play Billing non configure.' };
    }

    try {
      if (typeof billing.connect === 'function') await billing.connect();
      if (typeof billing.getProducts === 'function') {
        await billing.getProducts({ productIds: [productId], type: 'subs' });
      }

      let purchaseResult = null;
      if (typeof billing.purchaseProduct === 'function') {
        purchaseResult = await billing.purchaseProduct({ productId, type: 'subs' });
      } else if (typeof billing.purchaseSubscription === 'function') {
        purchaseResult = await billing.purchaseSubscription({ productId });
      } else {
        return { success: false, message: 'Aucune methode d\'achat supportee par le plugin.' };
      }

      const purchase = toPurchase(purchaseResult?.purchase || purchaseResult);
      if (!purchase.purchaseToken) {
        return { success: false, message: 'Achat Google Play invalide (token absent).' };
      }

      if (typeof billing.acknowledgePurchase === 'function') {
        await billing.acknowledgePurchase({ purchaseToken: purchase.purchaseToken });
      }

      return { success: true, purchase };
    } catch (error) {
      return { success: false, message: error?.message || 'Erreur Google Play Billing.' };
    }
  }

  async restorePurchases() {
    if (Capacitor.getPlatform() !== 'android') {
      return { success: false, purchases: [], message: 'Restauration disponible uniquement sur Android.' };
    }

    const billing = this.plugin;
    if (!billing) {
      return { success: false, purchases: [], message: 'Plugin Google Play Billing non configure.' };
    }

    try {
      if (typeof billing.connect === 'function') await billing.connect();
      let rawPurchases = [];
      if (typeof billing.getPurchases === 'function') {
        const response = await billing.getPurchases({ type: 'subs' });
        rawPurchases = response?.purchases || response || [];
      }
      const purchases = Array.isArray(rawPurchases) ? rawPurchases.map(toPurchase).filter((p) => p.purchaseToken) : [];
      return { success: true, purchases };
    } catch (error) {
      return { success: false, purchases: [], message: error?.message || 'Erreur restauration Google Play.' };
    }
  }
}

export { GOOGLE_PLAY_MONTHLY_PRODUCT_ID };
